import type { CSSObject } from '@emotion/react'
import { Color, Spacing, Typography } from '@opallabs/gem'
import { modernWithFallback } from '@opallabs/lapidary'
import type { WithRequiredTheme } from '@opallabs/lapidary'

type StyleProps = WithRequiredTheme

const sectionStyles = ({ theme }: StyleProps): CSSObject => ({
  alignItems: 'center',
  blockSize: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  paddingInline: Spacing.XL * 1.75,
  paddingBlockEnd: Spacing.XL * 2.5,
  paddingBlockStart: Spacing.XL * 1.75,
  backgroundColor: Color[theme].Surface.N100,
  color: Color[theme].Text.Default,
  ...modernWithFallback(
    [{ overflowBlock: 'auto' }, { overflowY: 'auto' }],
    'overflowBlock: auto'
  ),
})

const legend: CSSObject = {
  marginBlock: 0,
  marginInline: 'auto',
}

const link: CSSObject = {
  ...Typography.T500,
}

const headingStyles: CSSObject = {
  ...Typography.H500,
  marginBlockEnd: Spacing.S,
  marginBlockStart: Spacing.L * 1.5,
  textAlign: 'center',
}

const paragraphStyles: CSSObject = {
  ...Typography.H100,
  marginBlock: 0,
  marginInline: 0,
  maxInlineSize: Spacing.M * 36.125,
  textAlign: 'center',
}

const cardContainer: CSSObject = {
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: 'space-between',
  marginBlockEnd: Spacing.M * 2.125,
  marginBlockStart: Spacing.XL * 1.75,
  maxInlineSize: Spacing.M * 49.25,
  minBlockSize: Spacing.M * 8.25,
}

const iconOverrides = ({ theme }: StyleProps): CSSObject => ({
  fill: Color[theme].Surface.A200,
  path: {
    fill: Color[theme].Surface.A200,
  },
})

const footer = ({ theme }: StyleProps): CSSObject => ({
  ...Typography.H100,
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  inlineSize: '100%',
  insetBlockEnd: 0,
  justifyContent: 'space-between',
  paddingBlock: Spacing.M,
  paddingInline: Spacing.L,
  position: 'absolute',
  backgroundColor: Color[theme].Surface.N000,
  borderBlockStart: `1px solid ${Color[theme].Surface.N300}`,
  color: Color[theme].Text.Default,
})

export const styles = {
  cardContainer,
  footer,
  headingStyles,
  iconOverrides,
  legend,
  link,
  paragraphStyles,
  sectionStyles,
}
